import { render, staticRenderFns } from "./Purchase.vue?vue&type=template&id=608cdfe9"
import script from "./Purchase.vue?vue&type=script&lang=ts"
export * from "./Purchase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports